module.exports = __webpack_public_path__ + "static/media/name.eb356d54.png";